/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { ActivatedRoute } from "@angular/router";
import { Component, EventEmitter, Output, Input, TemplateRef } from "@angular/core";
import { IIconActionButton } from "app/shared/interfaces/IIconActionButton.interface";
import { IconActionButtonEventMessage } from "app/shared/components/icon-action-button-list/icon-action-button-list-message.model";

@Component({
    selector: "icon-action-button-list",
    templateUrl: "./icon-action-button-list.component.html",
    standalone: false
})

// Collection of IconActionButton components
export class IconActionButtonListComponent {
  @Input() actionItems: IIconActionButton[]; // the individual buttons to be renderd in the list
  @Output() onInvokeAction = new EventEmitter<IconActionButtonEventMessage>(); // emitted when child button is clicked and emits an event
  @Input() data: any;

  constructor() {}

  // bound to the onInvokeAction action of each child button
  processItemAction(message: string) {
    this.onInvokeAction.emit(new IconActionButtonEventMessage(message, this.data));
  }
}
